import angular from 'angular';

import { contactsChecker } from '../services/contactsChecker';

export default angular
  .module('estContactsChecker', [])
  .service('estContactsChecker', () => contactsChecker);
